import React from "react";

import {Text} from "@pg-design/text-module";

import {KitchenType} from "../../property_configurator/types/KitchenType";
import {FloorChoiceString} from "../types/FloorChoiceString";

const optionLabel = (text: string) => {
    return <Text variant="info_txt_1">{text}</Text>;
};

export const additionalAreasOptions = [
    {value: "Balkon lub taras", labelContent: optionLabel("Balkon lub taras")},
    {value: "Ogródek", labelContent: optionLabel("Ogródek")},
    {value: "", labelContent: optionLabel("Bez znaczenia")}
];

export const kitchenOptions = [
    {value: KitchenType.KITCHENETTE, labelContent: optionLabel("Aneks kuchenny")},
    {value: KitchenType.CLOSED, labelContent: optionLabel("Oddzielna kuchnia")},
    {value: "", labelContent: optionLabel("Bez znaczenia")}
];

export const dateOptions = [
    {value: "0", labelContent: optionLabel("Gotowe")},
    {value: "3", labelContent: optionLabel("Do 3 miesięcy")},
    {value: "6", labelContent: optionLabel("Do 6 miesięcy")},
    {value: "12", labelContent: optionLabel("Do roku")},
    {value: "36", labelContent: optionLabel("Do 3 lat")},
    {value: "", labelContent: optionLabel("Bez znaczenia")}
];

export const floorOptions = [
    {value: FloorChoiceString.GROUND, labelContent: optionLabel("Parter")},
    {value: FloorChoiceString.LOW_LEVELS, labelContent: optionLabel("Niskie piętra (1-4)")},
    {value: FloorChoiceString.HIGH_LEVELS, labelContent: optionLabel("Wysokie piętra (5+)")},
    {value: FloorChoiceString.LAST_LEVEL, labelContent: optionLabel("Ostatnie piętro")}
];

export const quartersOptions = [
    {value: "3", labelContent: optionLabel("Północ")},
    {value: "4", labelContent: optionLabel("Południe")},
    {value: "1", labelContent: optionLabel("Wschód")},
    {value: "2", labelContent: optionLabel("Zachód")}
];
import React from "react";

import {Text} from "@pg-design/text-module";

import {KitchenType} from "../../property_configurator/types/KitchenType";
import {FloorChoiceString} from "../types/FloorChoiceString";

const optionLabel = (text: string) => {
    return <Text variant="info_txt_1">{text}</Text>;
};

export const additionalAreasOptions = [
    {value: "Balkon lub taras", labelContent: optionLabel("Balkon lub taras")},
    {value: "Ogródek", labelContent: optionLabel("Ogródek")},
    {value: "", labelContent: optionLabel("Bez znaczenia")}
];

export const kitchenOptions = [
    {value: KitchenType.KITCHENETTE, labelContent: optionLabel("Aneks kuchenny")},
    {value: KitchenType.CLOSED, labelContent: optionLabel("Oddzielna kuchnia")},
    {value: "", labelContent: optionLabel("Bez znaczenia")}
];

export const dateOptions = [
    {value: "0", labelContent: optionLabel("Gotowe")},
    {value: "3", labelContent: optionLabel("Do 3 miesięcy")},
    {value: "6", labelContent: optionLabel("Do 6 miesięcy")},
    {value: "12", labelContent: optionLabel("Do roku")},
    {value: "36", labelContent: optionLabel("Do 3 lat")},
    {value: "", labelContent: optionLabel("Bez znaczenia")}
];

export const floorOptions = [
    {value: FloorChoiceString.GROUND, labelContent: optionLabel("Parter")},
    {value: FloorChoiceString.LOW_LEVELS, labelContent: optionLabel("Niskie piętra (1-4)")},
    {value: FloorChoiceString.HIGH_LEVELS, labelContent: optionLabel("Wysokie piętra (5+)")},
    {value: FloorChoiceString.LAST_LEVEL, labelContent: optionLabel("Ostatnie piętro")}
];

export const quartersOptions = [
    {value: "3", labelContent: optionLabel("Północ")},
    {value: "4", labelContent: optionLabel("Południe")},
    {value: "1", labelContent: optionLabel("Wschód")},
    {value: "2", labelContent: optionLabel("Zachód")}
];
